import React from 'react';
import PropTypes from 'prop-types';

import { CartRow, CartRowPropTypes } from './cart-row';
import CartTotal from './cart-total';

const Cart = (props) => {
  return (
    <div className="cart">
      {props.items.map(item => (
        <CartRow
          key={item[0].cart_id}
          {...item[0]}
          quantity={item.length}
          onRemove={props.onRemove}
        />
      ))}
      <CartTotal
        total={props.total}
        subtotal={props.subtotal}
        extraCosts={props.extraCosts}
      />
    </div>
  );
};

Cart.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape(CartRowPropTypes),
    ),
  ),
  total: CartTotal.propTypes.total,
  subtotal: CartTotal.propTypes.subtotal,
  extraCosts: CartTotal.propTypes.extraCosts,
  onRemove: PropTypes.func,
};

export default Cart;



// WEBPACK FOOTER //
// ./src/components/cart/cart.js